var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitlabs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 126,
    viewBox: "0 0 124 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_67842)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1168 122.341C65.1249 115.989 90.4943 138.997 102.841 161.037C107.762 169.818 113.538 180.131 112.12 192.387C109.607 214.118 85.5012 233.181 52.3177 239.545C51.3835 236.208 50.4494 232.873 49.5152 229.536C53.1444 225.757 58.5695 220.302 65.5033 214.052C76.155 204.451 78.3432 203.811 78.8547 200.78C80.5268 190.852 54.9964 182.541 45.914 165.081C38.1068 150.072 42.126 127.22 52.1168 122.339V122.341Z",
    fill: "#AF3DAA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9139 165.084C38.1067 150.074 42.1259 127.222 52.1167 122.341C54.737 121.062 57.8641 120.992 61.2808 121.846C59.4825 127.04 59.8375 130.798 60.7273 133.458C64.6858 145.324 81.8018 143.974 87.1499 157.477C90.5315 166.015 85.1555 170.252 89.9523 177.095C94.9244 184.187 103.054 182.996 105.564 189.904C107.435 195.051 103.745 197.978 105.165 202.314C105.56 203.522 106.34 204.736 107.65 205.888C98.8572 221.703 78.3945 234.545 52.3222 239.545C51.3881 236.208 50.4539 232.873 49.5198 229.536C53.149 225.757 58.5741 220.302 65.5078 214.052C76.1595 204.451 78.3478 203.811 78.8592 200.78C80.5314 190.852 55.0009 182.541 45.9186 165.081L45.9139 165.084Z",
    fill: "#AF3DAA"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7573 86.3062C76.358 86.3973 74.6228 86.9741 73.9362 94.2232C72.2827 111.699 81.3814 118.775 79.1394 128.252C76.9885 137.348 66.0215 141.762 54.7323 146.305C47.189 149.341 23.8538 158.729 10.2828 148.173C4.57282 143.729 3.94695 138.364 -0.128311 118.644C-10.4811 68.5409 -14.4909 64.2368 -10.1378 53.3889C-2.6622 34.7619 17.3567 27.0481 20.687 25.7659C56.2059 12.0829 98.1448 37.2327 114.719 66.1261C116.9 69.9305 129.934 92.6538 120.777 103.429C115.238 109.95 102.507 111.003 94.1069 106.556C82.883 100.615 80.4986 85.4491 76.7573 86.3062Z",
    fill: "url(#paint0_linear_106_67842)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.571 99.5621C115.683 99.5621 115.795 99.5387 115.903 99.4897C116.304 99.3075 116.482 98.8311 116.3 98.4294C115.996 97.7638 108.665 82.0303 91.7245 75.8205C91.3088 75.6664 90.8487 75.8812 90.6969 76.2969C90.5451 76.7126 90.7576 77.1727 91.1733 77.3245C107.467 83.2961 114.77 98.9362 114.842 99.095C114.978 99.3892 115.268 99.5644 115.571 99.5644V99.5621Z",
    fill: "url(#paint1_linear_106_67842)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0618 81.5912C49.1552 80.8695 49.8885 75.8765 54.0572 74.2767C56.131 73.4804 59.7742 73.2492 61.1918 75.5262C62.0816 76.9554 62.0045 79.2277 60.8345 80.3417C59.3562 81.75 57.4272 80.0755 54.7695 81.2338C51.5747 82.6257 51.0562 86.4861 49.9539 86.2292C49.0852 86.0284 48.8143 83.5015 49.0618 81.5912Z",
    fill: "url(#paint2_linear_106_67842)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M13.085 46.9833C15.327 53.0857 8.60109 58.373 11.483 64.9985C15.6143 74.4942 32.0344 69.6202 37.9055 79.0108C44.8627 90.1389 28.9306 108.392 35.5024 114.642C38.4987 117.489 41.9574 113.843 50.7151 115.842C63.1861 118.691 66.9344 128.547 72.7332 127.052C74.5571 126.583 76.7687 124.927 78.63 119.829C79.4404 122.657 79.8281 125.343 79.1391 128.255C76.9882 137.351 66.0213 141.765 54.732 146.307C47.1887 149.343 23.8535 158.732 10.2849 148.176C4.57488 143.731 3.94901 138.367 -0.126251 118.647C-10.479 68.5436 -14.4889 64.2395 -10.1357 53.3916C-7.76063 47.4784 -4.12209 42.6675 -0.154274 38.8094C8.39792 40.6988 11.9103 43.7908 13.085 46.9856V46.9833Z",
    fill: "url(#paint3_linear_106_67842)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8026 76.8878C47.8451 77.7589 37.1 89.2981 25.4114 86.3765C15.2337 83.8309 8.98425 73.9359 7.88895 65.6079C5.28499 45.8038 31.0864 29.1805 27.9056 25.173C26.0349 22.8166 16.0721 27.1908 9.08934 31.579C3.36296 35.1778 -20.6308 50.2551 -19.9886 75.5356C-19.9232 78.1022 -19.5098 94.3589 -8.75069 102.472C5.78009 113.43 28.2395 113.138 52.231 86.6474C50.9021 82.8641 50.1291 80.6665 48.8003 76.8855L48.8026 76.8878Z",
    fill: "url(#paint4_linear_106_67842)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.258 52.6231L89.6908 89.5759C89.3125 90.788 88.2078 91.6287 86.9397 91.6731L71.8134 93.873C69.8633 93.9431 68.3687 92.1542 68.7821 90.2485L78.983 52.4246C79.275 51.0817 80.4427 50.1102 81.8159 50.0682L98.3107 48.7393C100.368 48.6763 101.875 50.659 101.26 52.6254L101.258 52.6231Z",
    fill: "url(#paint5_linear_106_67842)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.704 53.8398L89.4758 89.7044C89.1068 90.8814 88.0372 91.6965 86.8064 91.7385L73.5134 93.873C71.6194 93.9408 70.1715 92.2056 70.5731 90.3536L80.5359 53.6226C80.8185 52.3195 81.9511 51.376 83.2847 51.334L97.8411 50.0658C99.8379 50.0028 101.3 51.9295 100.704 53.8375V53.8398Z",
    fill: "url(#paint6_linear_106_67842)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M70.5732 90.3538L80.0922 55.2599C80.7998 55.6079 81.8204 56.1473 82.7779 56.9694C86.5262 60.1852 88.6747 66.005 87.437 70.6594C85.8583 76.596 79.8003 76.7805 78.9642 81.7198C78.308 85.5872 81.4444 89.6788 84.0343 92.1824L73.5157 93.8709C71.6217 93.9386 70.1738 92.2034 70.5755 90.3514L70.5732 90.3538Z",
    fill: "url(#paint7_linear_106_67842)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7982 20.243C52.9831 23.1062 54.7043 26.0814 57.6002 26.7821C61.1056 27.6275 65.377 28.7975 67.222 29.8531C70.6083 31.7915 56.9089 29.5518 44.3095 29.2576C36.4439 29.0731 30.5658 28.1903 27.2588 27.5527C26.3714 27.3823 26.3037 26.1422 27.1608 25.8619C30.3089 24.8367 35.428 23.3304 39.7532 22.7862C45.1082 22.1136 50.8533 10.2942 50.8533 10.2942L55.4423 14.4629L53.7959 20.243H53.7982Z",
    fill: "url(#paint8_linear_106_67842)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.277 78.9547L93.5718 77.7987C92.9459 75.4003 90.6408 73.8332 88.1817 74.1368L84.4707 74.5946C83.3101 74.737 82.523 75.8417 82.7612 76.9883C83.1069 78.6441 83.9943 80.6269 86.276 80.4727C90.1504 80.2112 92.6259 85.8581 92.6259 85.8581L94.1136 83.7633C95.1271 82.3364 95.1902 80.4447 94.2794 78.9524L94.277 78.9547Z",
    fill: "url(#paint9_linear_106_67842)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0294 14.1849C67.9879 13.5988 72.4228 10.2708 72.3364 7.52209C72.2173 3.74343 63.5787 1.67428 59.2162 0.628024C54.8397 -0.420565 52.9854 -0.039897 51.7336 0.912941C50.4538 1.8868 49.6131 3.63133 49.3375 5.13532C49.188 5.95504 49.1787 7.08304 49.3188 9.32968C49.4426 11.3241 49.4076 11.2354 49.4589 11.8262C49.5827 13.2415 49.9704 15.7286 51.3483 19.1803C51.9228 18.5498 52.6841 17.7978 53.644 17.0575C54.0129 16.7726 55.4749 15.6679 57.1377 14.9977C59.9915 13.8487 61.624 14.5446 64.0271 14.1896L64.0294 14.1849Z",
    fill: "url(#paint10_linear_106_67842)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2415 15.334C49.2415 15.334 49.4984 20.8479 54.6946 23.2697C59.3467 25.4369 65.5214 15.724 63.8236 12.0131C63.2561 10.7753 61.5022 9.43015 59.704 9.01212C58.6414 8.7669 58.1206 8.97709 56.3924 8.54271C54.7997 8.14102 54.4891 7.76969 53.8749 7.89347C53.1042 8.0476 52.1233 8.92338 51.39 12.3517C51.0093 11.0135 50.1616 10.1191 49.2438 10.063C49.0967 10.0537 48.674 10.0957 48.326 10.3176C47.0672 11.1256 47.3148 13.1691 49.2415 15.334Z",
    fill: "url(#paint11_linear_106_67842)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_67842",
    x1: 34.37,
    y1: 7.85586,
    x2: 78.1399,
    y2: 163.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_67842",
    x1: 104.585,
    y1: 84.1719,
    x2: 96.9791,
    y2: 108.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_67842",
    x1: 53.9334,
    y1: 116.164,
    x2: 46.0702,
    y2: 310.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_67842",
    x1: 9.35309,
    y1: 14.8811,
    x2: 53.1229,
    y2: 170.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_106_67842",
    x1: 41.1729,
    y1: 89.7838,
    x2: -65.253,
    y2: 2.31424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_106_67842",
    x1: 108.472,
    y1: 88.95,
    x2: 70.1179,
    y2: 60.0496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_106_67842",
    x1: 91.1292,
    y1: 60.5541,
    x2: 72.8922,
    y2: 93.4387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_106_67842",
    x1: 67.7543,
    y1: 50.7783,
    x2: 96.1457,
    y2: 119.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_106_67842",
    x1: 45.0965,
    y1: -22.1653,
    x2: 52.9598,
    y2: 172.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_106_67842",
    x1: 86.9836,
    y1: 33.5665,
    x2: 94.8469,
    y2: 227.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_106_67842",
    x1: 68.6722,
    y1: -16.8197,
    x2: 60.3138,
    y2: 8.03354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_106_67842",
    x1: 56.7264,
    y1: 34.7925,
    x2: 64.5896,
    y2: 228.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_67842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 306.816,
    fill: "white",
    transform: "matrix(-1 0 0 1 124 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitlabs);
export default __webpack_public_path__ + "static/media/bitlabs.0ccd2eae80fd44f19ed221a098ef3ebd.svg";
export { ForwardRef as ReactComponent };